import React, { useState } from 'react'
import Popup from '../../components/popup/Popup'
import './AppStationPopup.scss'
import { AppScrollWrapperNew } from '../../widgets/AppScrollWrapper/AppScrollWrapper'
import Checkbox from '../../components/checkbox/Checkbox'
import AppBtn, { AppBtnColor, AppBtnSize } from '../../components/btn/AppBtn'
import { AppInput } from '../../components/AppInput/AppInput'
import { useGetStationsQuery } from '../../core/api/StationsApi'
import { useScrollHelper } from '../../shared/lib/hooks/useScrollHelper'
import {
  IStationDto,
  IStationsRequestDto,
} from '../../core/api/dto/StationsDto'
import { useGetCurrentUserQuery } from '../../core/api/UserApi'
import { IEdgeServers } from '../../core/api/dto/BuffetDishDto'
import { useTranslation } from 'react-i18next'

interface IChooseItems {
  [key: string]: boolean
}

interface AppStationPopupProps {
  onClose: () => void
  isLoading: boolean
  onSendItems: (value: string[]) => void
  isDeleteMode: boolean
  deleteStations: IEdgeServers[] | null
  onDeleteStationDishes: (value: string[]) => void
}

export const AppStationPopup = ({
  onClose,
  onSendItems,
  isLoading: isLoadingSend,
  isDeleteMode,
  deleteStations,
  onDeleteStationDishes,
}: AppStationPopupProps) => {
  const { t } = useTranslation()
  const [chooseItems, setChooseItems] = useState<IChooseItems>({})
  const [search, setSearch] = useState('')
  const { data: currentUser } = useGetCurrentUserQuery()
  const {
    dataList: stationsData,
    isLoading,
    onNextPageHandler,
    isNextPage,
  } = useScrollHelper<IStationDto, IStationsRequestDto>(
    useGetStationsQuery,
    {
      search: search || undefined,
      main_source:
        currentUser?.userRoles.restaurant.source?.toString() || undefined,
    },
    !currentUser,
    search,
  )

  const isEmpty = !Object.values(chooseItems).find((item) => item)

  const onChooseHandler = (value: string) => () => {
    setChooseItems((prev) => ({ ...prev, [value]: !prev[value] }))
  }

  const onSendDishesHandler = () => {
    if (!isEmpty) {
      const value = Object.entries(chooseItems)
        .filter(([key, value]) => !!key && value)
        .map(([key]) => key)
      if (isDeleteMode) {
        onDeleteStationDishes(value)
      } else {
        onSendItems(value)
      }
    }
  }

  return (
    <Popup closePopup={onClose} isLoading={isLoading}>
      <div className="station-wrap">
        <div className="title">{t('Выберите станции')}</div>
        <AppInput
          label="Поиск"
          value={search}
          placeholder="Например: фотобокс6147"
          onChange={setSearch}
          fullWidth
          border
        />
        <div className="station-list">
          <AppScrollWrapperNew>
            {(isDeleteMode && deleteStations
              ? deleteStations
              : stationsData
            ).map((item) => (
              <div key={item.id}>
                <Checkbox
                  name={item.name}
                  value={!!chooseItems[item.guid]}
                  onChange={onChooseHandler(item.guid)}
                  text={item.name}
                />
              </div>
            ))}
            {!stationsData.length && (
              <div className="empty-text">
                {t('Не найдены доступные станции')}
              </div>
            )}
            {isNextPage && (
              <AppBtn
                title="Показать ещё"
                color={AppBtnColor.lightViolet}
                sized={AppBtnSize.fullWidth}
                onClick={onNextPageHandler}
                disabled={isLoading}
                className="btn-grid-size"
              />
            )}
          </AppScrollWrapperNew>
        </div>
        <div className="buttons-block mt-15">
          <AppBtn
            sized={AppBtnSize.md}
            color={AppBtnColor.outlineViolet}
            title="Отмена"
            iconClassName="close"
            onClick={onClose}
          />
          <AppBtn
            sized={AppBtnSize.md}
            color={AppBtnColor.violetWhite}
            iconClassName={isDeleteMode ? 'basket' : 'add'}
            title={isDeleteMode ? 'Удалить' : 'Отправить'}
            onClick={onSendDishesHandler}
            disabled={isEmpty}
            isLoading={isLoadingSend}
          />
        </div>
      </div>
    </Popup>
  )
}
